import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import avatar1 from '../assets/images/avatar01.png';
import avatar2 from '../assets/images/avatar02.png';
import avatar3 from '../assets/images/avatar03.png';
import avatar4 from '../assets/images/avatar04.png';
import avatar5 from '../assets/images/avatar05.png';
import avatar6 from '../assets/images/avatar06.png';
import avatar7 from '../assets/images/avatar07.png';
import avatar8 from '../assets/images/avatar08.png';
import p_avanti from "../assets/images/p_avanti.png";


const IpadLobbyGame = () => {
        const navigate = useNavigate();
        const location = useLocation();
        const [players, setPlayers] = useState([]);
        const [waiting, setWaiting] = useState(true);
        const [message, setMessage] = useState('In attesa giocatori...');
         const [gameId, setGameId] = useState(null);
            const [isGameCreated, setIsGameCreated] = useState(false); // Stato temporaneo per interrompere il polling



    const avatarMap = {
        avatar01: avatar1,
        avatar02: avatar2,
        avatar03: avatar3,
        avatar04: avatar4,
        avatar05: avatar5,
        avatar06: avatar6,
        avatar07: avatar7,
        avatar08: avatar8,
    };

    const { userId, nickname, avatar } = location.state || {};


    useEffect(() => {
        const resetGameState = async () => {
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/reset-game`);
                setPlayers([]);
                setGameId(null);
                setIsGameCreated(false);
            } catch (error) {
                console.error("Errore durante il reset dello stato del gioco:", error);
            }
        };

        resetGameState();
    }, []); // Chiamata una volta all'inizio


    const pollForSecondPlayer = async () => {
        console.log("gameId="+gameId);
        console.log("isGameCreated="+isGameCreated);

        if (isGameCreated) return;
        try {
            //const response = await fetch('http://localhost:5000/api/joingame', {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/joingame`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId, nickname, avatar }),
            });

            const data = await response.json();

            if (data.status === 'ready') {
                setPlayers(data.players || []);
                setWaiting(false);

                // Crea una nuova partita solo se `isGameCreated` è ancora false
                if (!isGameCreated) {
                    const gameResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/create-game`, {
                        players: data.players,
                    });
                    setIsGameCreated(true); // Imposta `isGameCreated` a true
                    setGameId(gameResponse.data.gameId); // Imposta `gameId` dalla risposta
                }
            } else {
                // Continua ad aspettare finché il secondo giocatore non arriva
                setPlayers(data.players || []);  // Memorizziamo i dati del primo giocatore
                setMessage(data.message);
            }
        } catch (error) {
            console.error('Errore durante la connessione al server:', error);
        }
    };


    // Effettua il polling ogni 3 secondi finché il secondo giocatore non arriva
    useEffect(() => {
        const intervalId = setInterval(pollForSecondPlayer, 2000); // Poll ogni 3 secondi
        return () => clearInterval(intervalId); // Pulisce l'intervallo quando il componente viene smontato
    },  [userId, nickname, avatar, isGameCreated]);



    // Funzione per avviare il gioco
    const handleStartGame = () => {
        if (gameId) {
            navigate('/ipad/cover-cc', { state: { userId, casoClinico:1, gameId } });
        }
    };





        return (

            <div className="ipad_lobby flex flex-col w-full h-full  items-center justify-center relative bg-fixed overflow-hidden" style={{border: '0px solid red'}}>

                <div className="bg-black p-8 rounded-3xl shadow-md w-[547px] h-[526px] top-[158px] relative opacity-90">
                    <div className="flex justify-between items-center  p-4 rounded-lg shadow-lg" style={{border: '0px solid red'}}>

                        {/* Primo giocatore (a sinistra) */}
                        <div className="flex flex-col items-center">
                            {players.length >= 1 && (  // Mostra il primo giocatore se presente
                                <>
                                    <img
                                        src={avatarMap[players[0].avatar]}
                                        alt="Il tuo avatar"
                                        className="w-[170px] h-auto rounded-full mb-4 items-center border-4 border-verde"
                                    />
                                    {/* <h4 className="text-2xl font-bold text-white">{players[0].nickname}</h4>*/}

                                    <div className="bg-verde text-white font-bold px-8 py-2 text-2xl">
                                        {players[0].nickname}
                                    </div>

                                </>
                            )}
                        </div>

                        {/* Secondo giocatore (a destra) */}
                        <div className="flex flex-col items-center">
                            {players.length > 1 ? (
                                <>
                                    <img
                                        src={avatarMap[players[1].avatar]}
                                        alt={`Avatar selezionato: ${players[1].avatar}`}
                                        className="w-[170px] h-auto rounded-full mb-4 items-center border-4 border-blue-light"
                                    />
                                    {/*<h4 className="text-2xl font-bold text-white">{players[1].nickname}</h4>*/}
                                    <div className="bg-blue-light text-white font-bold px-8 py-2 text-2xl">
                                        {players[1].nickname}
                                    </div>
                                </>
                            ) : (
                                <p className="text-white">In attesa del secondo giocatore...</p>
                            )}
                        </div>



                        {/* Mostra un messaggio di attesa */}
                        {/*{waiting && <p className="text-center  text-white">{message}</p>}*/}


                    </div>

                    {/* Mostra un pulsante immagine solo quando entrambi i giocatori sono presenti */}


                        {players.length === 2 && (
                            <div className="flex justify-center items-center  pt-10" style={{border: '0px solid yellow'}}>
                                <button onClick={handleStartGame}
                                    className="w-auto"
                                    style={{background: 'none', border: '0px solid yellow'}}>
                                    <img
                                        src={p_avanti} // Immagine del pulsante
                                        alt="Inizia Gioco"
                                        className="w-[225px] h-auto "
                                    />
                                </button>
                            </div>
                        )}



                </div>
            </div>
        );
};


export default IpadLobbyGame;
